import Cookies from 'js-cookie';

function ClosedController($scope, $rootScope, $timeout, SiteWinnersSvc, NextDrawSvc, DrawsSvc, $location, $routeParams, PurchaseTicketSvc) {
  'ngInject';

  $scope.WinnersList = {};
  SiteWinnersSvc.list({}, function (data) {
    $scope.WinnersList = data;
  });

	jQuery(document).ready(function ($) {
    setTimeout(function(){
      $('header').remove();
      $('#toast').remove();
    }, 500);
	});


};

export default {
  name: 'closedController',
  fn: ClosedController
}